import {
  BOTTOM_BY_ID,
  CLOTH_COLOR_BY_ID,
  DEFAULT_APPEARANCE,
  GENDER_BY_ID,
  HAIR_COLOR_BY_ID,
  HAIR_STYLE_BY_ID,
  LAST_APPEARANCE_KEY,
  NAME_MAX_LENGTH,
  SKIN_BY_ID,
  TOP_BY_ID,
} from './catalog.js';

export function defaultAppearance() {
  return { ...DEFAULT_APPEARANCE };
}

export function repairName(name) {
  const trimmed = String(name ?? '').replace(/\s+/g, ' ').trim().slice(0, NAME_MAX_LENGTH);
  return trimmed || DEFAULT_APPEARANCE.name;
}

function pickId(value, catalog, fallback) {
  return catalog.has(value) ? value : fallback;
}

export function repairAppearance(appearance) {
  const source = appearance && typeof appearance === 'object' ? appearance : {};
  return {
    name: repairName(source.name),
    gender: pickId(source.gender, GENDER_BY_ID, DEFAULT_APPEARANCE.gender),
    skin: pickId(source.skin, SKIN_BY_ID, DEFAULT_APPEARANCE.skin),
    hairStyle: pickId(source.hairStyle, HAIR_STYLE_BY_ID, DEFAULT_APPEARANCE.hairStyle),
    hairColor: pickId(source.hairColor, HAIR_COLOR_BY_ID, DEFAULT_APPEARANCE.hairColor),
    top: pickId(source.top, TOP_BY_ID, DEFAULT_APPEARANCE.top),
    topColor: pickId(source.topColor, CLOTH_COLOR_BY_ID, DEFAULT_APPEARANCE.topColor),
    bottom: pickId(source.bottom, BOTTOM_BY_ID, DEFAULT_APPEARANCE.bottom),
    bottomColor: pickId(source.bottomColor, CLOTH_COLOR_BY_ID, DEFAULT_APPEARANCE.bottomColor),
  };
}

export function appearancesEqual(a, b) {
  const left = repairAppearance(a);
  const right = repairAppearance(b);
  return Object.keys(DEFAULT_APPEARANCE).every((key) => left[key] === right[key]);
}

export function loadLastAppearance(storage = globalThis.localStorage) {
  try {
    return repairAppearance(JSON.parse(storage?.getItem(LAST_APPEARANCE_KEY) || 'null'));
  } catch {
    return defaultAppearance();
  }
}

export function saveLastAppearance(appearance, storage = globalThis.localStorage) {
  storage?.setItem(LAST_APPEARANCE_KEY, JSON.stringify(repairAppearance(appearance)));
}
